import { Skeleton } from "@/components/ui/skeleton";
import { useLocaleCtx } from "@/contexts/locale";
import { AspectRatio } from "@radix-ui/react-aspect-ratio";

const CardSkeleton = () => {
  const { lang } = useLocaleCtx();
  return (
    <div className="relative h-full w-full">
      <Skeleton className="h-full w-full rounded-[40px] bg-primary/5" />
      <div className="absolute inset-0 flex items-center justify-center">
        <span className="animate-pulse font-opensans text-white opacity-40">
          {lang === "en" ? "Loading..." : "تحميل..."}
        </span>
      </div>
    </div>
  );
};

export const LoadingCard = () => (
  <div className="select-none p-1">
    <div className="flex flex-col gap-6 rounded-[40px] bg-[#0E0D0C] px-4 pb-8 pt-4">
      <div className="relative">
        <AspectRatio ratio={16 / 9}>
          <div className="relative h-full w-full rounded-[40px]">
            <CardSkeleton />
          </div>
        </AspectRatio>
      </div>
    </div>
  </div>
);
